// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cddf5c8","453":"9d0f63ff","455":"4947debe","977":"175c8501"}[chunkId] + ".chunk.js";
};